module.exports = __webpack_public_path__ + "static/media/attachment.8ae26b4a.svg";